import React, { useState } from "react";

import { IdentitySearchQueryContext } from "./identity-search-context";
import { IdentitySearchQuery } from "types/search-display";

interface IdentitySearchContextWrapperProps {
  children: React.ReactNode;
}

const IdentitySearchContextWrapper = ({
  children,
}: IdentitySearchContextWrapperProps) => {
  const [identitySearchQueryState, setIdentitySearchQueryState] =
    useState<IdentitySearchQuery>({
      identityID: "",
      userID: "",
      emailLocal: "",
      emailDomain: "",
      matchExactEmail: false,
    });

  const identitySearchContextValue = {
    identitySearchQueryState: identitySearchQueryState,
    setIdentitySearchQueryState: setIdentitySearchQueryState,
  };

  return (
    <IdentitySearchQueryContext.Provider value={identitySearchContextValue}>
      {children}
    </IdentitySearchQueryContext.Provider>
  );
};

export default IdentitySearchContextWrapper;
